var flashcard_frame = require('./flashcard_frame');
var checkProgress = require('./flashcard_checkprogress');
var flashcardSlide = require('./flashcard_slide');
var report = require('./flashcard_report');
// var ajaxCalls = require('./ajaxCalls');
var SettingsModal = require('./flashcard_settings_modal');
var resultsModal = require('./flashcard_results_modal');

var Flashcard = function(flashcard,modal,dashboardLink) {
    var _global = { flashcard:flashcard,modal:modal,currentSlide: 0,dashboardLink:dashboardLink,flashcards:[]};


    SettingsModal(_global,function() {
        // start after the modal is done

        $('#'+modal).modal('hide');
        $(flashcard).html('');
        var frame = flashcard_frame();
        $(flashcard).append(frame);
        _global.currentSlide = 0;
        checkProgress(_global);
        flashcardSlide(_global);
        // buttons
        $('#show-answer').click( function() {
            // toggle flipped
            var slide = _global.flashcards[_global.currentSlide];
            slide.flipped = true;
            toggleShow();
        });

        $(frame).find('button.previous').click(function() {
            if (_global.currentSlide > 0 ) {
                _global.currentSlide--;
                resetAnswer();
                flashcardSlide(_global);
                checkProgress(_global);
            }
        });

        $(frame).find('button.next').click(function() {
            if (_global.currentSlide < _global.flashcards.length ) {
                _global.currentSlide++ ;
                resetAnswer();
                flashcardSlide(_global);
                checkProgress(_global);
            }
        });
        $('#finish').click(function() {
            // take over the node
            resultsModal(_global);
        });

        // Report Button
        $('#report').click(function() {
            report(_global);
        })
    });

//


//
    function resetAnswer() {
        var answer = $('.answer');
        $(answer).addClass('no-show');
        var explanation = $('.explanation');
        $(explanation).addClass('no-show');
    }
    function toggleShow() {
        var answer = $('.answer');
        if ($(answer).hasClass('no-show')) {
            $(answer).removeClass('no-show');
        } else {
            $(answer).addClass('no-show');
        }
        var explanation = $('.explanation');
        if ($(explanation).hasClass('no-show')) {
            $(explanation).removeClass('no-show');
        } else {
            $(explanation).addClass('no-show');
        }
    }
}

module.exports = Flashcard;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard.js
// module id = 306
// module chunks = 0